import React, { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { claimCompany } from '../../api/api'

import './styles.scss'

import Subscribe from './subscribe/Subscribe'
import playButton from '../../assets/img/play-button.png'
import { createCookie, readCookie } from '../../utils/cookies'
import { requestSettings } from '../../store/settings/actions'
import { Link } from 'react-router-dom'
import { Routes } from '../../routing/routes'
import { PagesManagementStore } from '../../store/pages-management/types'
import { SettingsStore } from '../../store/settings/types'
import { Plann3rStore } from '../../store/types'
import { companyAddPage,
  setActiveCompany,
  setActivePage,
  setActiveTab } from '../../store/pages-management/actions'
import { ApiResponse, Company, MeetingPage, Tiers } from '../../types/plann3r'
import { hasClass } from '../../utils/general'

const Master: FC = () => {
  const [company, setcompany] = useState('')
  const [showAddPopup, setshowAddPopup] = useState(false)
  const [showSubscribePopup, setshowSubscribePopup] = useState(false)

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.pages.master,
  )

  const { companies, active_company, active_page } = useSelector(
    (state: Plann3rStore): PagesManagementStore => state.pagesManagement,
  )

  const { user_id, tier, onboarding } = useSelector(
    (state: Plann3rStore): SettingsStore => state.settings,
  )

  const dispatch = useDispatch()

  const closeModal = () => {
    setshowAddPopup(false)
    setshowSubscribePopup(false)
  }

  const finishedSubscription = () => {
    closeModal()
    window.location.reload()
  }

  const handleClaimCompany = (response: ApiResponse) => {
    if (response.success === true) {
      dispatch(requestSettings())
      closeModal()
    } else {
      alert(strings.claim_alert)
    }
  }

  const handleClickList = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault()
    const x = document.getElementById('Checklist')

    if (x) {
      if (hasClass(x, 'hideList')) {
        x.classList.remove('hideList')
        createCookie('onboarding', 'show', 60)
      } else {
        x.classList.add('hideList')
        createCookie('onboarding', 'hide', 60)
      }
    }
  }

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    closeModal()

    handleClaimCompany(await claimCompany({
      company: company.replace(/\s+/g, '_').toLowerCase(),
    }))
  }

  const renderPageNavItem = (page: MeetingPage) => {
    return (
      <li className={active_page === page.id ? 'selected' : ''} key={page.id}>
        <span
          onClick={() => {
            dispatch(setActivePage(page.id))
            document.getElementById('details')?.scrollIntoView()
          }}
          role="presentation"
        >
          {page.name}
        </span>
      </li>
    )
  }

  const renderCompanyNav = (company: Company) => {
    return (
      <div className="activeCompany" key={company.id}>
        <h3
          onClick={() => {
            dispatch(setActiveCompany(company.id))
            document.getElementById('details')?.scrollIntoView()
          }}
          role="presentation"
        >
          {company.name}
        </h3>
        <div className="flex flex-row items-center">
          {company.employees[0] && (
            <img
              className="avatar"
              src={company.employees[0].avatar}
              alt={
                company.employees[0].first_name
                  ? company.employees[0].first_name
                  : company.employees[0].email
              }
              title={
                company.employees[0].first_name
                  ? company.employees[0].first_name
                  : company.employees[0].email
              }
            />
          )}
          {company.employees[1] && (
            <img
              className="avatar"
              src={company.employees[1].avatar}
              alt={
                company.employees[1].first_name
                  ? company.employees[1].first_name
                  : company.employees[1].email
              }
              title={
                company.employees[1].first_name
                  ? company.employees[1].first_name
                  : company.employees[1].email
              }
            />
          )}
          {company.employees[2] && (
            <img
              className="avatar"
              src={company.employees[2].avatar}
              alt={
                company.employees[2].first_name
                  ? company.employees[2].first_name
                  : company.employees[2].email
              }
              title={
                company.employees[2].first_name
                  ? company.employees[2].first_name
                  : company.employees[2].email
              }
            />
          )}
          {company.employees[3] && (
            <img
              className="avatar"
              src={company.employees[3].avatar}
              alt={
                company.employees[3].first_name
                  ? company.employees[3].first_name
                  : company.employees[3].email
              }
              title={
                company.employees[3].first_name
                  ? company.employees[3].first_name
                  : company.employees[3].email
              }
            />
          )}
          {company.employees.length - 4 > 0 && (
            <span className="inline-block ml-4">
              {' '}
              + {company.employees.length - 4} more
            </span>
          )}
        </div>

        {active_company === company.id && (
          <ul className="companyNav">
            {company.admin && (
              <li className="mt-2">
                <button
                  onClick={() => {
                    dispatch(setActiveTab(null))
                  }}
                  className="button is-outlined"
                >
                  {strings.settings}
                </button>
              </li>
            )}
            <h4>{strings.meeting_pages}</h4>
            <ul className="pagesNav">{company.pages.map(renderPageNavItem)}</ul>
            <li className="pagesLi">
              <button
                className="button addPageButton"
                onClick={() => {
                  if (company.pages.length > 0 && tier?.toLowerCase() === Tiers.FREE) {
                    setshowSubscribePopup(true)
                  } else {
                    dispatch(companyAddPage(user_id))
                  }
                }}
              >
                <i className="fa fa-plus" /> {strings.add_page}
              </button>
            </li>
          </ul>
        )}
      </div>
    )
  }

  const onboardingStatus = readCookie('onboarding') ?? 'show'

  let content
  let onboardingWidget

  if (onboarding && tier?.toLowerCase() === Tiers.FREE) {
    onboardingWidget = (
      <div id="DIV_1">
        <div id="DIV_2" onClick={handleClickList} role="presentation">
          <div id="DIV_3" />
          <div id="DIV_7">Get Started</div>

          {onboarding.tasks_open > 0 && (
            <div id="DIV_8">{onboarding.tasks_open}</div>
          )}
        </div>
        <div
          id="Checklist"
          className={onboardingStatus === 'hide' ? 'hideList' : ''}
        >
          <div id="DIV_10">
            <div id="DIV_11">
              <div id="DIV_12">
                <h2 id="H2_13">Getting Started</h2>
                <div id="DIV_14">
                  {onboarding.completion_rate < 0.95 &&
                    'Complete these tasks and get 1 month of Plann3r Professional for free'}
                  {onboarding.completion_rate > 0.95 && (
                    <span className="onboardingcCompleted">
                      Woohoo, you are Awesome!{' '}
                      <span role="img" aria-label="" aria-labelledby="">
                        🎉
                      </span>{' '}
                      You earned Plann3r professional free for 1 month! Use the
                      code{' '}
                      <span className="listHighlighted">
                        {' '}
                        ONBOARDINGCOMPLETED
                      </span>{' '}
                      when upgrading your account.
                    </span>
                  )}
                </div>
                {onboarding.completion_rate < 0.95 && (
                  <div id="DIV_15">
                    <span id="SPAN_16">
                      {onboarding.completion_rate * 100}%
                    </span>
                    <span id="SPAN_17">
                      {onboarding.completion_rate === 0.25 && (
                        <span className="completed25" id="PROGRESS_INSIDE" />
                      )}
                      {onboarding.completion_rate === 0.5 && (
                        <span className="completed50" id="PROGRESS_INSIDE" />
                      )}
                      {onboarding.completion_rate === 0.75 && (
                        <span className="completed75" id="PROGRESS_INSIDE" />
                      )}
                      {onboarding.completion_rate > 0.95 && (
                        <span className="completed100" id="PROGRESS_INSIDE" />
                      )}
                    </span>
                  </div>
                )}
              </div>
              <div id="minimizeList" onClick={handleClickList} role="presentation">
                <svg id="svg_20">
                  <defs id="defs_21" />
                  <g id="g_22">
                    <path id="path_23" />
                  </g>
                </svg>
              </div>
            </div>
            <div id="DIV_24">
              <ul id="UL_25">
                <li id="LI_26" className="taskDone">
                  <span id="A_27">
                    <span id="SPAN_28">
                      <span className="checkmark">✔</span>
                    </span>
                  </span>
                  <p id="P_34">
                    Create your account
                    <img
                      className="playbutton"
                      id="create_account"
                      alt="Create account"
                      src={playButton}
                    />
                  </p>
                </li>
                <Link to={Routes.PAGES_MANAGEMENT + '?product_tour_id=10987'}>
                  <li
                    id="LI_39"
                    className={onboarding.step2 === true ? 'taskDone' : ''}
                  >
                    <span id="A_40">
                      <span id="SPAN_41">
                        <span className="checkmark">✔</span>
                      </span>
                    </span>
                    <p id="P_47">
                      Customize your meeting page
                      <img
                        className="playbutton"
                        id="create_account"
                        alt="Customize page"
                        src={playButton}
                      />
                    </p>
                  </li>
                </Link>
                <Link to={Routes.PAGES_MANAGEMENT + '?product_tour_id=10987'}>
                  <li
                    id="LI_52"
                    className={onboarding.step3 === true ? 'taskDone' : ''}
                  >
                    <span id="A_53">
                      <span id="SPAN_54">
                        <span className="checkmark">✔</span>
                      </span>
                    </span>
                    <p id="P_60">
                      Schedule a meeting on your page
                      <img
                        className="playbutton"
                        id="create_account"
                        alt="Schedule a meeting"
                        src={playButton}
                      />
                    </p>
                  </li>
                </Link>
                <Link to={Routes.PAGES_MANAGEMENT + '?product_tour_id=10987'}>
                  <li
                    id="LI_65"
                    className={onboarding.step4 === true ? 'taskDone' : ''}
                  >
                    <span id="A_66">
                      <span id="SPAN_67">
                        <span className="checkmark">✔</span>
                      </span>
                    </span>
                    <p id="P_73">
                      Share your page with a collegue
                      <img
                        className="playbutton"
                        id="create_account"
                        alt="Share"
                        src={playButton}
                      />
                    </p>
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (showAddPopup) {
    content = (
      <div className="modal-content">
        <div className="box">
          <form onSubmit={submit}>
            <div className="field">
              <label>{strings.company_name}</label>
              <input
                id="company_name"
                type="text"
                className="grey full-width"
                value={company}
                placeholder={strings.placeholder}
                onChange={(e) => {
                  setcompany(e.target.value)
                }}
                required
              />
            </div>
            <button className="button is-primary full-width">
              {strings.add_company_button}
            </button>
          </form>
        </div>
      </div>
    )
  } else if (showSubscribePopup) {
    content = (
      <div className="modal-content">
        <Subscribe afterSubmit={finishedSubscription} />
      </div>
    )
  }

  if (tier?.toLowerCase() !== Tiers.FREE) {
    return (
      <div className="master">
        <div className="master_top">
          <button
            className="button is-primary addCompanyButton first-step"
            onClick={() => {
              setshowAddPopup(true)
            }}
          >
            {strings.add_company}
          </button>
          {companies.map(renderCompanyNav)}
        </div>
        <div
          className={
            'modal' + (showAddPopup || showSubscribePopup ? ' is-active' : '')
          }
        >
          <div className="modal-background" onClick={closeModal} role="presentation" />
          {content}
          <button className="modal-close" onClick={closeModal} />
        </div>
      </div>
    )
  } else {
    return (
      <div className="master">
        <div className="master_top">
          Do you want to add more pages, manage your company and employees and
          use our integrations?{' '}
          <span role="img" aria-label="" aria-labelledby="">
            👇
          </span>
          <br />
          <br />
          <button
            className="button is-primary addCompanyButton first-step"
            onClick={() => {
              if (companies.length > 0 && tier?.toLowerCase() === Tiers.FREE) {
                setshowSubscribePopup(true)
              } else {
                setshowAddPopup(true)
              }
            }}
          >
            Upgrade Plann3r
          </button>
        </div>
        <div
          className={
            'modal' + (showAddPopup || showSubscribePopup ? ' is-active' : '')
          }
        >
          <div className="modal-background" onClick={closeModal} role="presentation" />
          {content}
          <button className="modal-close" onClick={closeModal} />
        </div>
        {onboardingWidget}
      </div>
    )
  }
}

export default Master
